import { useEffect, useState } from 'react';

/**
 * @description
 * CSS 미디어쿼리의 현재 매치 여부를 반환한다.
 *
 * CSS 로 `hidden` 처리한 요소도 React 는 그대로 마운트하므로,
 * "안 보이는데 스크립트는 다 받는" 상황이 생긴다 (매물 목록 지도 = 모바일에서 약 340KB).
 * 그런 곳에서 마운트 자체를 건너뛰기 위한 훅이다.
 *
 * 주의: 렌더 결과가 뷰포트 폭에 의존하게 되므로, 레이아웃 경계는 반드시
 * Tailwind 쪽 값과 같은 수를 써야 한다 (docs/responsive-breakpoints.md).
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;

    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);

    setMatches(mql.matches);
    mql.addEventListener('change', onChange);

    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
};
